module.exports = {
  setPerms: {
    PUBLIC: 0,
    GUEST: 1,
    MANAGER: 2,
    MEMBER: 4,
    ADMIN: 8,
  },
}